import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setPostFtux } from 'api/set-post-ftux';

export const useSetPostFtux = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setPostFtux,
    onSuccess: () => {
      // Refresh all queries so ftuxComplete and user profile are up to date
      queryClient.invalidateQueries();
    },
  });
};
